import Marquee from "react-fast-marquee";
import { AnimatedSection, NoiseTexture } from "../shared";
import { INFLUENCERS } from "./constants";

export function InfluencerCarousel() {
  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <NoiseTexture />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0c0c0c] to-[#0a0a0a]" />

      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="mb-12 text-center flex flex-col items-center">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-white/35 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-violet-500/60 before:to-transparent">
              Social Proof
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] gradient-text-dark">
              Top Influencer about AGNT.Hub
            </h2>
          </div>
        </AnimatedSection>
      </div>

      <div className="relative z-10">
        <Marquee speed={40} pauseOnHover gradient={false} autoFill>
          {INFLUENCERS.map((item, i) => (
            <a
              key={i}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 inline-block !w-[280px] bg-[#111] rounded-2xl overflow-hidden border border-white/[0.06] hover:border-white/[0.12] transition-all duration-300 hover:shadow-lg group no-underline mx-2.5"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={`${process.env.PUBLIC_URL}/influencers/${item.thumb}`}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-red-600 flex items-center justify-center opacity-0 group-hover:opacity-90 transition-opacity shadow-lg">
                    <svg
                      viewBox="0 0 24 24"
                      fill="white"
                      className="w-5 h-5 ml-0.5"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h4 className="text-sm font-semibold text-white/90 leading-tight line-clamp-1 mb-3">
                  {item.title}
                </h4>
                <div className="flex items-center gap-2.5">
                  {item.avatar ? (
                    <img
                      src={`${process.env.PUBLIC_URL}/influencers/${item.avatar}`}
                      alt={item.channel}
                      className="w-7 h-7 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-7 h-7 rounded-full bg-red-500 flex items-center justify-center text-white text-[10px] font-bold">
                      {item.channel[0]}
                    </div>
                  )}
                  <div>
                    <div className="text-xs font-semibold text-white/70">
                      {item.channel}
                    </div>
                    <div className="text-[10px] text-white/40">{item.subs}</div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </Marquee>
      </div>
    </section>
  );
}

export default InfluencerCarousel;
